/* Patırtı mobil menü: kategori sekmeleri, alt çubuk "Kategoriler" tetiği, geri tuşuyla kapanma. drawer-panel (global.js) odak tuzağı / Escape / kaydırma kilidini sağlar. */
(function () {
  'use strict';
  if (window.__patirtiMobileNav) return;
  window.__patirtiMobileNav = true;
  const mobile = window.matchMedia('(max-width: 767px)');
  const findMenu = () => document.querySelector('[data-mobile-nav]');

  function select(menu, button) {
    menu.querySelectorAll('[data-mnav-cat]').forEach(node => {
      const on = node === button;
      node.classList.toggle('is-active', on);
      node.setAttribute('aria-expanded', String(on));
      const pane = document.getElementById(node.getAttribute('aria-controls'));
      if (pane) pane.hidden = !on;
    });
    const panes = menu.querySelector('[data-mnav-panes]');
    if (panes) panes.scrollTop = 0;
  }

  function setup(menu) {
    if (!menu || menu.dataset.mnavReady) return;
    menu.dataset.mnavReady = 'true';
    let pushed = false;
    let pendingUrl = null;
    const go = () => { if (!pendingUrl) return; const url = pendingUrl; pendingUrl = null; location.assign(url); };

    menu.addEventListener('click', event => {
      const cat = event.target.closest('[data-mnav-cat]');
      if (cat) { event.preventDefault(); select(menu, cat); return; }
      /* Menü geçmişe kayıt eklediyse, bağlantıya gitmeden önce o kaydı geri al (geçmiş temiz kalsın). */
      const link = event.target.closest('a[href]');
      if (!link || event.defaultPrevented || event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank') return;
      if (!pushed || !(history.state && history.state.patirtiMnav)) return;
      let url;
      try { url = new URL(link.href, location.href); } catch (_) { return; }
      if (url.origin !== location.origin) return;
      event.preventDefault();
      pendingUrl = url.href; pushed = false;
      history.back();
      setTimeout(go, 400);
    });

    menu.addEventListener('keydown', event => {
      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
      const items = Array.from(menu.querySelectorAll('.mnav__cat'));
      const index = items.indexOf(document.activeElement);
      if (index < 0) return;
      event.preventDefault();
      items[(index + (event.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length].focus();
    });

    menu.addEventListener('dialog:opened', event => {
      if (event.target !== menu) return;
      const active = menu.querySelector('.mnav__cat.is-active');
      if (active && active.scrollIntoView) active.scrollIntoView({ block: 'nearest' });
      try { history.pushState({ patirtiMnav: true }, ''); pushed = true; } catch (_) { pushed = false; }
    });
    menu.addEventListener('dialog:closed', event => {
      if (event.target !== menu || !pushed) return;
      pushed = false;
      if (history.state && history.state.patirtiMnav) history.back();
    });
    window.addEventListener('popstate', () => {
      if (pushed) { pushed = false; if (typeof menu.close === 'function') menu.close(false); }
      go();
    });
    const onMedia = () => { if (!mobile.matches && menu.hasAttribute('open') && typeof menu.close === 'function') menu.close(false); };
    if (mobile.addEventListener) mobile.addEventListener('change', onMedia);
  }

  /* Alt gezinme çubuğundaki "Kategoriler" butonu (header'dan bağımsız section). */
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-mobile-menu-open]');
    if (!trigger) return;
    const menu = findMenu();
    if (!menu || typeof menu.open !== 'function') return;
    event.preventDefault();
    setup(menu);
    menu.open(trigger);
  });

  const init = () => setup(findMenu());
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
